import { notificationStatuses } from "./constant";

export const getStatusMeaning = (status) => {
  if (!status) return null;
  return notificationStatuses.find(
    (item) => item.status.toLowerCase() === status.toLowerCase(),
  );
};

export const formatDate = (inputDate) => {
  if (!inputDate) return null;

  const date = new Date(inputDate);
  if (Number.isNaN(date.getTime())) return null;

  const month = String(date.getMonth() + 1).padStart(2, "0");
  const day = String(date.getDate()).padStart(2, "0");
  const year = date.getFullYear();

  return `${month}/${day}/${year}`;
};
